// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from '../services/vuestic-ui'
import store from '../store/index'
import router from '../router/index'
import { VuesticPlugin } from '../services/vuestic-ui/components'
import '../i18n/index'
import VueClipboard from 'vue-clipboard2'

import '../metrics'
import '../registerServiceWorker'

import { consoleBuildInfo } from 'vue-cli-plugin-build-info/plugin'
import authApi from '@/api/auth'
consoleBuildInfo()

Vue.use(VuesticPlugin)
Vue.use(VueClipboard)

Vue.use(ColorThemePlugin, {
  // override colors here.
})

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  const loginRoute = to.name === 'interviewInbox'
    ? { name: 'login', query: { redirect: '/admin/openJob/interviewInbox' } }
    : { name: 'login' }
  if (to.path === '/auth/login' || to.path === '/auth/signup') {
    next()
  } else {
    const token = localStorage.getItem('token')
    // 校验token的有效性
    if (token == null || token === '') {
      next(loginRoute)
    } else {
      authApi.checkToken().then(response => {
        if (response.success === true) {
          next()
        } else {
          next(loginRoute)
        }
      }).catch(function () {
        next(loginRoute)
      })
    }
  }
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
